// extracted by mini-css-extract-plugin
export var half = "TxtImg-module--half--E0oiB";
export var imgFirst = "TxtImg-module--imgFirst--l4UA+";
export var third = "TxtImg-module--third--jK532";
export var txtFirst = "TxtImg-module--txtFirst--ugWan";